module.exports = __webpack_public_path__ + "files/2ad11dbf70d521ce42ece8b912ff7686.png";